module.exports = __webpack_public_path__ + "img/gPay-Supplier-Active.0df4a5ed.svg";